import { CALLBACK_REQUEST, CALLBACK_REQUEST_SUCCESS, CALLBACK_REQUEST_ERROR, CALLBACK_REQUEST_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CallbackRequest = (state = initialState, action) => {
  switch (action.type) {
    case CALLBACK_REQUEST:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CALLBACK_REQUEST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CALLBACK_REQUEST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CALLBACK_REQUEST_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CallbackRequest;
